<template>
  <b-dropdown variant="link" no-caret right toggle-class="text-decoration-none p-0" menu-class="theme-dropdown-menu">
    <template slot="button-content">
      <i class="fa fa-globe" :title="$t('language.label') + ': ' + $t('language.' + $i18n.locale)" style="font-size:1.1rem"></i>
    </template>
    <b-dropdown-header>{{ $t('language.label') }}</b-dropdown-header>
    <b-dropdown-item v-for="l in locales" :key="l" @click="change(l)" :active="$i18n.locale === l">
      {{ $t('language.' + l) }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { SUPPORTED_LOCALES, setLocale } from '@/i18n'

export default {
  name: 'LanguageSwitcher',
  data () {
    return { locales: SUPPORTED_LOCALES }
  },
  methods: {
    change (locale) {
      setLocale(locale)
    }
  }
}
</script>
